import React from 'react';
import { Link } from 'gatsby';

export type CategoryIconCardProps = {
    url: string;
    icon: React.FC<React.SVGProps<SVGElement>>;
    title: string;
};

const CategoryIconCard: React.FC<CategoryIconCardProps> = ({ url, icon: Icon, title }) => (
    <Link to={url} className="cat-icon-card">
        <div className="cat-icon-card__icon">
            <Icon />
        </div>
        <h3 className="h5 cat-icon-card__title">{title}</h3>
    </Link>
);

export default CategoryIconCard;